(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bai-hero-sequence"] && !Shopify.designMode) return;
  try {
    
  class BaiHeroSequence extends HTMLElement {
    connectedCallback() {
      this.frames = [...this.querySelectorAll('.bai-hero__frame')];
      this.interval = Math.max(300, parseInt(this.dataset.interval, 10) || 1000);
      this.index = 0;
      if (this.frames.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Wait until every frame has decoded so the first loop never flickers.
      const decodes = this.frames.map((frame) => {
        const img = frame.querySelector('img');
        if (!img) return Promise.resolve();
        const ready = img.complete ? Promise.resolve() : new Promise((r) => { img.onload = r; img.onerror = r; });
        return ready.then(() => (img.decode ? img.decode().catch(() => {}) : null));
      });
      Promise.all(decodes).then(() => this.start());

      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
    }

    disconnectedCallback() { this.stop(); }

    start() {
      if (this.timer || this.frames.length < 2) return;
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() { clearInterval(this.timer); this.timer = null; }

    next() {
      this.frames[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.frames.length;
      this.frames[this.index].classList.add('is-active');
    }
  }
  if (!customElements.get('bai-hero-sequence')) customElements.define('bai-hero-sequence', BaiHeroSequence);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
